var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"750px"}},[_c('support-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }